import {IconProps} from '../../types/IconProps'

const CircledAlertIcon = ({height, width, color}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width ?? '20'}
      height={height ?? '20'}
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z'
        stroke={color ?? '#F45045'}
        strokeWidth='1.25'
        strokeMiterlimit='10'
      />
      <path
        d='M10 10.625V6.25'
        stroke={color ?? '#F45045'}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 14.375C10.5178 14.375 10.9375 13.9553 10.9375 13.4375C10.9375 12.9197 10.5178 12.5 10 12.5C9.48223 12.5 9.0625 12.9197 9.0625 13.4375C9.0625 13.9553 9.48223 14.375 10 14.375Z'
        fill={color ?? '#F45045'}
      />
    </svg>
  )
}

export default CircledAlertIcon
